import { render, staticRenderFns } from "./upFiles.vue?vue&type=template&id=2217f6d5&scoped=true&"
import script from "./upFiles.vue?vue&type=script&lang=js&"
export * from "./upFiles.vue?vue&type=script&lang=js&"
import style0 from "./upFiles.vue?vue&type=style&index=0&id=2217f6d5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217f6d5",
  null
  
)

export default component.exports